export const HeadCells = [
  {
    field: "title",
    headerTitle: "Title",
  },
  {
    field: "subTitle",
    headerTitle: "Sub Title",
  },
  {
    field: "price",
    headerTitle: "Price",
  },
  {
    field: "accountType",
    headerTitle: "Account Type",
  },
  {
    field: "description",
    headerTitle: "Description",
  },
];
